import { devDebug } from "./devLog";

const REPLY_AUDIO_SELECTOR = 'audio[data-testid^="reply-audio-"]';
const AUDIO_PATH = "/api/v1/uploads/audio/";

function encodedObjectKey(src) {
  try {
    const url = new URL(src, window.location.origin);
    const markerIndex = url.pathname.indexOf(AUDIO_PATH);
    if (markerIndex < 0) return null;
    const rawKey = url.pathname.slice(markerIndex + AUDIO_PATH.length);
    if (!rawKey) return null;
    return rawKey
      .split("/")
      .map((part) => encodeURIComponent(decodeURIComponent(part)))
      .join("/");
  } catch (error) {
    devDebug("reply audio: invalid source", error?.message);
    return null;
  }
}

function patchReplyAudio(audio) {
  if (!(audio instanceof HTMLAudioElement) || audio.dataset.replyAudioPatched === "true") return;

  const objectKey = encodedObjectKey(audio.currentSrc || audio.getAttribute("src") || "");
  if (!objectKey) return;

  audio.dataset.replyAudioPatched = "true";
  audio.preload = "metadata";

  const originalSource = audio.currentSrc || audio.getAttribute("src") || "";
  const sameOriginSource = `${window.location.origin}${AUDIO_PATH}${objectKey}`;
  const candidates = Array.from(new Set([sameOriginSource, originalSource].filter(Boolean)));
  let candidateIndex = 0;

  const useCandidate = (index) => {
    const next = candidates[index];
    if (!next || audio.src === next) return;
    audio.src = next;
    audio.load();
  };

  audio.addEventListener("error", () => {
    candidateIndex += 1;
    if (candidateIndex < candidates.length) {
      useCandidate(candidateIndex);
      return;
    }
    devDebug("reply audio: all playback URLs failed", objectKey);
  });

  useCandidate(0);
}

function patchAll(root = document) {
  root.querySelectorAll?.(REPLY_AUDIO_SELECTOR).forEach(patchReplyAudio);
}

export function startReplyAudioPlaybackFix() {
  patchAll();
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.(REPLY_AUDIO_SELECTOR)) patchReplyAudio(node);
        patchAll(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  return () => observer.disconnect();
}
